module.exports = __webpack_public_path__ + "static/media/15.5289e0e2.jpeg";